import { call, put, takeLatest } from "redux-saga/effects";
import GetProductInformationRequest from "Communication/ApiClasses/GetProductInformationRequest";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleGetProductInformation(action) {
  // Start the spinner
  yield put(doLoadingStart(STRINGS.COMMON.API_KEYS.GET_PRODUCT_INFORMATION));

  // Form API request
  const getProductInfo = new GetProductInformationRequest([
    action.applicationId,
    action.productType,
    action.doximProductId,
  ]);
  try {
    // Call the API
    const result = yield call(getProductInfo.getData);
    // Give a call to the callback function
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.GET_PRODUCT_INFORMATION_ERROR,
      error: e.message,
    });
  } finally {
    // Stop the spinner
    yield put(doLoadingFinish(STRINGS.COMMON.API_KEYS.GET_PRODUCT_INFORMATION));
  }
}

// watcher
export default function* handleGetProductInformationSaga() {
  yield takeLatest(
    actionTypes.GET_PRODUCT_INFORMATION,
    handleGetProductInformation
  );
}
